<template>
  <div :class="`vue-toast ${isClose ? 'hide':''}`">

    <div class="vue-toast-header">
      <div :class="`vue-toast-header-status ${toast.type}`"></div>
      <div class="vue-toast-header-title" v-html="toast.title"></div>
      <div class="vue-toast-header-close" @click="close"><img class="vue-toast-header-close__icon" src="/assets/images/icons/close.svg"></div>
    </div>


    <div class="vue-toast-body" v-html="toast.message"></div>

  </div>
</template>

<script>
import CookieService from "../../../service/CookieService";

export default {
  name: "Toast",
  props: {
    toast: {
      type: Object,
      default: {},
    },
  },
  data: function () {
    return {
      isHidden: false,
    };
  },
  computed: {
    isClose() {
      return this.isHidden;
    },
  },
  mounted() {
    setTimeout(() => {
      this.destroy();
    }, 3500);
  },
  methods: {
    close() {
      this.destroy();
    },
    destroy() {
      if (!this.isHidden) {
        CookieService.destroy('toast').then(data => {
          if (data.status === 200) {
            this.isHidden = true;
          }
        });
      }

    },
  }
}
</script>

<style scoped>

</style>